var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDownloaded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17.939,
    viewBox: "0 0 17 17.939",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3502",
    "data-name": "Tracciato 3502",
    d: "M9,16H6.252c-.234,0-.352,0-.45.01A2,2,0,0,0,4.01,17.8c-.01.1-.01.216-.01.451H4c0,.28,0,.42.012.531a2,2,0,0,0,2.159,1.77c.111-.009.248-.037.523-.092l.3-.059a4.748,4.748,0,0,0,.731-.176A2,2,0,0,0,8.971,18.7,4.749,4.749,0,0,0,9,17.951V9.279c0-1.57,0-2.355.453-2.908s1.223-.707,2.762-1.015l2-.4c2.214-.443,3.32-.664,4.052-.064S19,6.622,19,8.879V9m0,5v1.95a4.749,4.749,0,0,1-.029.752,2,2,0,0,1-1.249,1.524,4.746,4.746,0,0,1-.731.176l-.3.059c-.274.055-.412.082-.523.092a2,2,0,0,1-2.159-1.77C14,16.672,14,16.532,14,16.253h0c0-.235,0-.352.01-.451A2,2,0,0,1,15.8,14.01c.1-.01.216-.01.451-.01Zm0,0V9m0,0L9,11",
    transform: "translate(-3 -3.631)",
    fill: "none",
    stroke: "#222",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownloaded);
export default __webpack_public_path__ + "static/media/icon-downloaded.7c685a1636aac11fdbeddd1769bfd381.svg";
export { ForwardRef as ReactComponent };